import { STORAGE_KEYS } from '../config';

const genUUID = () => (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;

export const getSavedMessages = () => {
  const saved = localStorage.getItem(STORAGE_KEYS.MESSAGES);
  if (!saved) return [];
  try {
    const parsed = JSON.parse(saved);
    if (!Array.isArray(parsed)) {
      localStorage.removeItem(STORAGE_KEYS.MESSAGES);
      return [];
    }
    return parsed;
  } catch (error) {
    localStorage.removeItem(STORAGE_KEYS.MESSAGES);
    return [];
  }
};

export const saveMessages = (messages) => {
  try {
    localStorage.setItem(STORAGE_KEYS.MESSAGES, JSON.stringify(messages));
  } catch (error) {
    // Quota exceeded or unavailable — swallow, don't crash the app.
  }
};

export const getSavedSessionId = () => {
  return localStorage.getItem(STORAGE_KEYS.SESSION_ID) || `session-${genUUID()}`;
};

export const saveSessionId = (sessionId) => {
  try {
    localStorage.setItem(STORAGE_KEYS.SESSION_ID, sessionId);
  } catch (error) {
    // Quota exceeded or unavailable — swallow, don't crash the app.
  }
};

export const clearMessages = () => {
  localStorage.removeItem(STORAGE_KEYS.MESSAGES);
};

export const generateSessionId = () => {
  return `session-${genUUID()}`;
};
